// src/components/ThemeToggle.jsx
"use client";
import * as React from "react";
import { Moon, Sun } from "lucide-react";
import { Button } from "components/ui/button";

function useTheme() {
  const [theme, setThemeState] = React.useState(() => {
    if (typeof window === "undefined") {
      return "system";
    }
    return localStorage.getItem("theme") || "system";
  });

  const updateMetaThemeColor = (activeTheme) => {
    const metaThemeColor = document.querySelector('meta[name="theme-color"]');
    if (metaThemeColor) {
      metaThemeColor.setAttribute(
        "content",
        activeTheme === "dark" ? "#0c140f" : "#14532d"
      );
    }
  };

  const setTheme = (newTheme) => {
    const root = window.document.documentElement;

    root.classList.remove("light", "dark");

    if (newTheme === "system") {
      const systemTheme = window.matchMedia("(prefers-color-scheme: dark)")
        .matches
        ? "dark"
        : "light";
      root.classList.add(systemTheme);
      updateMetaThemeColor(systemTheme);
    } else {
      root.classList.add(newTheme);
      updateMetaThemeColor(newTheme);
    }

    localStorage.setItem("theme", newTheme);
    setThemeState(newTheme);
  };

  React.useEffect(() => {
    setTheme(theme);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [theme]);

  return { theme, setTheme };
}

export function ThemeToggle({ className }) {
  const { theme, setTheme } = useTheme();

  const toggleTheme = () => {
    setTheme(theme === "light" ? "dark" : "light");
  };

  return (
    <Button variant="ghost" size="icon" onClick={toggleTheme} className={className}>
      <Sun className="h-[1.2rem] w-[1.2rem] rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" />
      <Moon className="absolute h-[1.2rem] w-[1.2rem] rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />
      <span className="sr-only">Toggle theme</span>
    </Button>
  );
}
